// extracted by mini-css-extract-plugin
export default {"container":"Patterns_container__UryAv","header":"Patterns_header__X0qXM","backButton":"Patterns_backButton__72Y6K"};